export const ObserverOption = {
  root: null,
  rootMargin: `500px`
};
